import { AsyncStorage } from 'react-native';
import { Observable } from 'rxjs';
import muster from '@dbk-legacy/muster';
import { getValues, watchValues } from '@dbk-legacy/muster/utils';
// import Orientation from '@dbk-legacy/react-native-orientation';
import { variable, constant } from '@dbk-legacy/muster/helpers';
import lget from 'lodash/get';
import last from 'lodash/last';
import { ORIENTATIONS, APP_NAMESPACE, PAGE } from '../../../../src/constants';
import ui from '../data/ui.json';

let DEBUG = false;

export default () =>
  muster()
    .path('ui.debug', {
      get({ res }) {
        return res.value(DEBUG);
      },
      set({ req, res }) {
        DEBUG = req.value;
        return res.ok();
      },
    })


    .path(
      'ui.income.timeline',
      ({ res }) => res.value(ui.income.timeline)
    )
    .path('ui.customtitle', variable(''))
    .path('ui.positions.currentPosition.transactions.length', variable(0))
    .path('ui.positions.currentPosition.transactions.moveToTransaction', {
      call: async ({ req }, { get, set, call }) => {
        await set('ui.positions.transactions.moveToTransactions.showSpinner', true);
        const assetCategory = req.args[0];
        const positionIndex = req.args[1];
        const link = req.args[2];
        await call('ui.history.push', { pathname: link });
        const portfolioId = await getValues(get('app.user.selectedPortfolioId'));
        const [transactionLength] = await getValues(get([`roster.data.portfoliosById.["${portfolioId}"].${assetCategory}.positions.[${positionIndex}].transactions.length`]));
        set('ui.positions.currentPosition.transactions.length', transactionLength);
        await set('ui.positions.transactions.moveToTransactions.showSpinner', false);

      },
    })
    .path('ui.positions.transactions.moveToTransactions.showSpinner', variable(false))
    .path('ui.change.customtitle', {
      call: async ({ req }, { get, set, call }) => {
        const value = req.args[0];

        console.log("ui.change.customtitle=>", value.custometitle);
        set('ui.customtitle', value.custometitle);
      },
    })

    .path('ui.backlink.isDisable', variable(false))
    .path('ui.backlink.onClicked', variable(""))
    .path('ui.backlink.onClickedEvent', {
      call: async ({ req }, { get, set, call }) => {

      },
    })

    .path('ui.component.initialPath', variable(""))
    .path('ui.component.initialPathGuid', variable(""))

    .path('ui.toastMsg', variable(null))

    .match('ui.static[{keys:assetCategory}].position.labels', requests =>
      requests.map(({ req, res }) =>
        res.value(lget(ui, `${req.params.assetCategory}.position.labels`)
          || lget(ui, 'position.labels'))
      )
    )
    .match('ui.static[{keys:assetCategory}].position.options', requests =>
      requests.map(({ req, res }) =>
        res.value(lget(ui, `${req.params.assetCategory}.position.options`)
          || lget(ui, 'position.options'))
      )
    )
    .match('ui.static[{keys:assetCategory}].position.detailsGroups', requests =>
      requests.map(({ req, res }) =>
        res.value(lget(ui, `${req.params.assetCategory}.position.detailsGroups`)
          || lget(ui, 'position.detailsGroups'))
      )
    )
    .match('ui.static[{keys:assetCategory}].cashGroups.detailsGroups', requests =>
      requests.map(({ req, res }) => res.value(lget(ui, `cashGroups.${req.params.assetCategory}.detailsGroups`)
        || lget(ui, 'cashGroups.detailsGroups'))
      )
    )
    .match('ui.static[{keys:assetCategory}].mmDepositesGroups.detailsGroups', requests =>
      requests.map(({ req, res }) => res.value(lget(ui, `mmDepositesGroups.${req.params.assetCategory}.detailsGroups`)
        || lget(ui, 'mmDepositesGroups.detailsGroups'))
      )
    )
    .match('ui.static[{keys:assetCategory}].fundsGroups.detailsGroups', requests =>
      requests.map(({ req, res }) => res.value(lget(ui, `fundsGroups.${req.params.assetCategory}.detailsGroups`)
        || lget(ui, 'fundsGroups.detailsGroups'))
      )
    )
    .match('ui.static[{keys:assetCategory}].optionsGroups.detailsGroups', requests =>
      requests.map(({ req, res }) => res.value(lget(ui, `optionsGroups.${req.params.assetCategory}.detailsGroups`)
        || lget(ui, 'optionsGroups.detailsGroups'))
      )
    )
    .match('ui.static[{keys:assetCategory}].othersGroups.detailsGroups', requests =>
      requests.map(({ req, res }) => res.value(lget(ui, `othersGroups.${req.params.assetCategory}.detailsGroups`)
        || lget(ui, 'othersGroups.detailsGroups'))
      )
    )
    .match('ui.static[{keys:assetCategory}].structuredProductsGroups.detailsGroups', requests =>
      requests.map(({ req, res }) => res.value(lget(ui, `structuredProductsGroups.${req.params.assetCategory}.detailsGroups`)
        || lget(ui, 'structuredProductsGroups.detailsGroups'))
      )
    )
    .match('ui.static[{keys:assetCategory}].creditGroups.detailsGroups', requests =>
      requests.map(({ req, res }) => res.value(lget(ui, `creditGroups.${req.params.assetCategory}.detailsGroups`)
        || lget(ui, 'creditGroups.detailsGroups'))
      )
    )
    .match('ui.static[{keys:assetCategory}].limitGroups.detailsGroups', requests =>
      requests.map(({ req, res }) => res.value(lget(ui, `limitGroups.${req.params.assetCategory}.detailsGroups`)
        || lget(ui, 'limitGroups.detailsGroups'))
      )
    )
    .match('ui.static[{keys:assetCategory}].bondsGroups.detailsGroups', requests =>
      requests.map(({ req, res }) => res.value(lget(ui, `bondsGroups.${req.params.assetCategory}.detailsGroups`)
        || lget(ui, 'bondsGroups.detailsGroups'))
      )
    )
    .match('ui.static[{keys:assetCategory}].sharesGroups.detailsGroups', requests =>
      requests.map(({ req, res }) => res.value(lget(ui, `sharesGroups.${req.params.assetCategory}.detailsGroups`)
        || lget(ui, 'sharesGroups.detailsGroups'))
      )
    )
    .match('ui.static[{keys:assetCategory}].futuresGroups.detailsGroups', requests =>
      requests.map(({ req, res }) => res.value(lget(ui, `futuresGroups.${req.params.assetCategory}.detailsGroups`)
        || lget(ui, 'futuresGroups.detailsGroups'))
      )
    )
    .match('ui.static[{keys:assetCategory}].swapsGroups.detailsGroups', requests =>
      requests.map(({ req, res }) => res.value(lget(ui, `swapsGroups.${req.params.assetCategory}.detailsGroups`)
        || lget(ui, 'swapsGroups.detailsGroups'))
      )
    )
    .match('ui.static[{keys:assetCategory}].commoditiesGroups.detailsGroups', requests =>
      requests.map(({ req, res }) => res.value(lget(ui, `commoditiesGroups.${req.params.assetCategory}.detailsGroups`)
        || lget(ui, 'commoditiesGroups.detailsGroups'))
      )
    )
    .match('ui.static[{keys:assetCategory}].insurancePoliciesGroups.detailsGroups', requests =>
      requests.map(({ req, res }) => res.value(lget(ui, `insurancePoliciesGroups.${req.params.assetCategory}.detailsGroups`)
        || lget(ui, 'insurancePoliciesGroups.detailsGroups'))
      )
    )
    .match('ui.static[{keys:assetCategory}].pawnGroups.detailsGroups', requests =>
      requests.map(({ req, res }) => res.value(lget(ui, `pawnGroups.${req.params.assetCategory}.detailsGroups`)
        || lget(ui, 'pawnGroups.detailsGroups'))
      )
    )
    .match('ui.static[{keys:assetCategory}].propertyGroups.detailsGroups', requests =>
      requests.map(({ req, res }) => res.value(lget(ui, `propertyGroups.${req.params.assetCategory}.detailsGroups`)
        || lget(ui, 'propertyGroups.detailsGroups'))
      )
    )
    .match('ui.static[{keys:assetCategory}].maturitiesAssets.options', requests =>
      requests.map(({ req, res }) => res.value(lget(ui, `maturitiesAssets.${req.params.assetCategory}.options`)
        || lget(ui, 'maturitiesAssets.options'))
      )
    )
    .match('ui.static[{keys:assetCategory}].maturitiesAssets.detailsGroups', requests =>
      requests.map(({ req, res }) => res.value(lget(ui, `maturitiesAssets.${req.params.assetCategory}.detailsGroups`)
        || lget(ui, 'maturitiesAssets.detailsGroups'))
      )
    )
    .match('ui.static[{keys:assetCategory}].maturitiesAssetsTablet.options', requests =>
      requests.map(({ req, res }) => res.value(lget(ui, `maturitiesAssetsTablet.${req.params.assetCategory}.options`)
        || lget(ui, 'maturitiesAssetsTablet.options'))
      )
    )
    .match('ui.static.*', (requests) =>
      requests.map(({ req, res }) => res.value(lget(ui, req.params['*'])))
    )
    .match('ui.section[{keys:section}].*', (requests) =>
      requests.map(({ req, res }) => res.value(
        lget(ui, ['section', req.params.section, req.params['*']]))
      )
    )
    .path('ui.title', ({ res }, { get,call }) =>
      watchValues(get('ui.history.currentLocation.route'))
        .switchMap(([currentRouteConfig]) =>
          watchValues(get('portfolio.selectedAssetDesc'))
            .switchMap(([selectedAssetDesc]) => {
              const paths = ['ui.static.defaultTitle'];
              // const [selectedAssetName] =  getValues(get('portfolio.assetClassName'));

              if (currentRouteConfig.section) {
                paths.push(`ui.section.${currentRouteConfig.section}.title`);
              } else if (currentRouteConfig.assetCategory) {
                paths.push('portfolio.selectedAssetDesc');
              } else if (currentRouteConfig.maturitiesAssetsTitle) {
                paths.push('maturities.detailTitle');
              }
             //call('ui.state.portfolio.genericAssets.resetSort')
              return watchValues(get(paths))
                .map(([selectedAssetDesc, defaultTitle, title]) => res.value(selectedAssetDesc || title || defaultTitle));
            }))
    )
    .path('ui.orientation', {
      get: () => {
        let prevOrientation = ORIENTATIONS.portrait;

        function provideOrientation(sub, orientation) {
          sub.next({
            path: 'ui.orientation',
            value: (orientation === ORIENTATIONS.unknown) ? prevOrientation : orientation,
          });

          if (orientation !== ORIENTATIONS.unknown) {
            prevOrientation = orientation;
          }
        }

        return Observable.create((sub) => {
          const cb = (orientation) => {
            provideOrientation(sub, orientation);
          };

          Orientation.getOrientation((err, orientation) => {
            provideOrientation(sub, orientation);
          });

          Orientation.addOrientationListener(cb);
          return () => Orientation.removeOrientationListener(cb);
        });
      },
    })
    .match('ui.state.*', {
      get(requests) {
        return Promise.all(requests.map(({ req, res }) =>
          AsyncStorage.getItem(`${APP_NAMESPACE}${req.path}`)
            .then((value) => {
              const hasStoredValue = (value !== null);
              if (hasStoredValue) {
                return JSON.parse(value);
              }
              const defaultValue = lget(ui.state, req.params['*']);
              return defaultValue;
            })
            .then((value) => res.value(value))
        ));
      },
      set(requests) {
        return requests.map(({ req, res }) => {
          AsyncStorage.setItem(`${APP_NAMESPACE}${req.path}`, JSON.stringify(req.value));
          return res.ok();
        });
      },
    })
    .match([
      'ui.state.portfolio.changeSort',
      'ui.state.portfolio[{keys:asset}].changeSort',
      'ui.state.position.changeSort',
      'ui.state.maturities.changeSort',
      'ui.state.maturitiesAssets.changeSort',
    ], {
      call: async ({ req }, { get, set,call }) => {
        const [{ key }] = req.args;
        // TODO cough
        const pathRoot = req.path.slice(0, -'.changeSort'.length);
        // TODO clear any expanded nodes
        await set(`${pathRoot}.expandedItem`, null);

        const [currentAscending, currentKey] = await getValues(get([
          `${pathRoot}.ascending`,
          `${pathRoot}.selectedKey`,
        ]));
        if (key !== currentKey) {
          await set([
            { path: `${pathRoot}.selectedKey`, value: key },
            { path: `${pathRoot}.ascending`, value: false },
          ]);
        } 
        else {
        if(currentAscending){
        await set([
          { path: `${pathRoot}.selectedKey`, value: null },
          { path: `${pathRoot}.ascending`, value: null},
        ]);
        if(`${pathRoot}`=== `ui.state.portfolio.genericAssets`){
          await call('ui.state.portfolio.genericAssets.resetAssetSort')
        }
        }
        else{
        await set(`${pathRoot}.ascending`, !currentAscending);
        }
        }
       if (`${pathRoot}`=== `ui.state.portfolio.genericAssets`){
          const [isAscending] = await getValues(get([
            `${pathRoot}.ascending`
           ]));
        await call('ui.change.genericAssets.sort', {key , isAscending})
        }
        
      },
    })  
    .match([
      'ui.state.portfolio.resetSort',
      'ui.state.portfolio[{keys:asset}].resetSort',
      'ui.state.maturities.resetSort',
      'ui.state.maturitiesAssets.resetSort',
    ], {
      call: async ({ req }, { set ,call}) => {
        const pathRoot = req.path.slice(0, -'.resetSort'.length);
        await set([
          { path: `${pathRoot}.ascending`, value: null },
          { path: `${pathRoot}.selectedKey`, value: null },
        ]);
      if(`${pathRoot}`=== `ui.state.portfolio.genericAssets`){
        await call('ui.state.portfolio.genericAssets.resetAssetSort')
      }
      }
    })
    .path('ui.chartAssets.selectedId', ({ res }, { get }) =>
      watchValues(get('portfolio.assets.length'))
        .switchMap(([assetsLength]) =>
          watchValues(get('ui.state.portfolio.chartAssets.selectedId'))
            .map(([selectedAssetId]) =>
              res.value(selectedAssetId > assetsLength - 1 ? 0 : selectedAssetId)
            )
        )
    )
    // eslint-disable-next-line no-shadow
    .match('ui.positions[{keys:asset}].currentPosition.*', (requests, { get }) =>
      watchValues(get('ui.history.currentLocation.pathname'))
        .map(([pathname]) => {
          const params = pathname.split('/');

          if (params.length < 3) {
            return requests.map(({ res }) => res.notFound());
          }

          // TODO muster history param
          const id = last(params);

          return requests.map(({ req, res }) =>
            res.redirect(
              `portfolio.${req.params.asset}.positionsById["${id}"].${req.params['*']}`
            ));
        })
    )
    .match('ui.positions[{keys:asset}].currentPosition.transactionCount', (requests, { get }) =>
      watchValues(get('ui.history.currentLocation.pathname'))
        .map(([pathname]) => {
          const params = pathname.split('/');

          if (params.length < 3) {
            return requests.map(({ res }) => res.value(0));
          }

          const id = last(params);

          return requests.map(({ req, res }) =>
            res.redirect(
              `portfolio.${req.params.asset}.positionsById["${id}"].transactions.length`
            ));
        })
    )
    .path('ui.state.position.transactionPageOffset', variable(0))
    .match('ui.positions[{keys:asset}].currentPosition.transactionPageSize', (requests, { get }) =>
      watchValues(get(['ui.state.position.transactionPageOffset',
        `ui.positions.${requests[0].req.params.asset}.currentPosition.transactionCount`]))
        .map(([offset, length]) =>
          requests.map(({ req, res }) => res.value(Math.min(length, PAGE.pageSize, length - offset)))
        )
    )
    .path('ui.bottomNav.items', (requests, { get }) =>
      watchValues(get('ui.history.currentLocation.pathname'))
        .map(([pathname]) => {
          let matched = false;
          let defaultIndex;

          const items = ui.bottomNav
            .map((item, i) => {
              const active = !!((item.pattern && !matched && new RegExp(item.pattern).test(pathname)) || pathname.includes(item.title) == true);

              if (active) {
                matched = true;
              } else if (!matched && item.default) {
                defaultIndex = i;
              }

              return {
                key: item.key,
                title: item.title,
                icon: item.icon,
                location: item.location,
                restricted: item.restricted,
                active,
              };
            });

          if (!matched && defaultIndex != null) {
            items[defaultIndex].active = true;
          }

          return {
            path: 'ui.bottomNav.items',
            value: items,
          };
        })
    )

    .path('ui.change.toastMsg', {
      call: async ({ req }, { get, set, call }) => {
        const value = req.args[0];

        set('ui.toastMsg', value.toastMsg);
      },
    })

    .path('ui.legal.items', constant(ui.legal))
    .match('ui.inactive[{keys:property}]', (requests) =>
      requests.map(({ req, res }) => res.value(lget(ui, `inactive.${req.params.property}`)))
    )
    .path('ui.componentProps', variable(null))

    .path('ui.change.genericAssets.sort', {
      call: async ({ req }, { get, set, call }) => {
        const [ currentKey] = await getValues(get([
          'ui.state.portfolio.genericAssets.assetSortKey'
        ]));
        const [{ key , isAscending}] = req.args;
         const [positionsLength]= await getValues(get(['portfolio.genericAssets.positions.length']));
         const [assetPageSize]= await getValues(get(['app.config.assetPageSize']));
         if(positionsLength>assetPageSize){
         if (key !== currentKey) {
          await set([
            { path: 'ui.state.portfolio.genericAssets.assetSortKey', value: key },
            { path: 'ui.state.portfolio.genericAssets.assetSortAscending', value: isAscending },
          ]); 
        } 
        else{
          await set('ui.state.portfolio.genericAssets.assetSortAscending', isAscending);
        }
          
          await call('ui.state.portfolio.genericAssets.resetPage');
       }
      const [ asc] = await getValues(get([
        'ui.state.portfolio.genericAssets.assetSortAscending'
      ]));
      },
    })
    .path('ui.state.portfolio.genericAssets.resetPage', {
      call: async ({ req }, { get, set, call }) => {
        await set('portfolio.genericAssets.positions.pageOffset', 0);
        const [pageSize]= await getValues(get(['portfolio.genericAssets.positions.pageSize']));
      },
    })
    .path('ui.state.portfolio.genericAssets.resetAssetSort', {
      call: async ({ req }, { get, set, call }) => {
        await set('ui.state.portfolio.genericAssets.assetSortKey',null);
        await set('ui.state.portfolio.genericAssets.assetSortAscending',null);
      },
    
  })
   .path('ui.state.portfolio.genericAssets.assetSortKey', variable(""))
   .path('ui.state.portfolio.genericAssets.assetSortAscending', variable(""));
